var _filter, _circle, _ellipse, _circle2, _circle3, _circle4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg10D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "sun10d",
    cx: "50%",
    cy: "30%",
    r: "40%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFE066",
      stopOpacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FF8C42",
      stopOpacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "heavyRainClouds10d",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#CBD5E1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#64748B",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "heavyRainShadow10d"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 4,
    stdDeviation: 3,
    floodColor: "#475569",
    floodOpacity: 0.4
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 6,
    fill: "url(#sun10d)",
    opacity: 0.6
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: 35,
    rx: 22,
    ry: 14,
    fill: "url(#heavyRainClouds10d)",
    filter: "url(#heavyRainShadow10d)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 30,
    r: 11,
    fill: "url(#heavyRainClouds10d)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 30,
    r: 13,
    fill: "url(#heavyRainClouds10d)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 25,
    r: 9,
    fill: "url(#heavyRainClouds10d)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1E40AF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 52,
    x2: 32,
    y2: 72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 55,
    x2: 42,
    y2: 75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: 53,
    x2: 52,
    y2: 73
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 56,
    x2: 62,
    y2: 76
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 58,
    x2: 37,
    y2: 78
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 61,
    x2: 47,
    y2: 81
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 59,
    x2: 57,
    y2: 79
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10D);
export default __webpack_public_path__ + "static/media/10d.9703df248ebcb2a1f9642617749a0059.svg";
export { ForwardRef as ReactComponent };